var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49984 8.33594C7.60441 8.33594 8.49984 7.44051 8.49984 6.33594C8.49984 5.23137 7.60441 4.33594 6.49984 4.33594C5.39527 4.33594 4.49984 5.23137 4.49984 6.33594C4.49984 7.44051 5.39527 8.33594 6.49984 8.33594Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49984 14.6693C7.83317 12.0026 11.8332 10.2815 11.8332 6.66927C11.8332 3.72375 9.44536 1.33594 6.49984 1.33594C3.55432 1.33594 1.1665 3.72375 1.1665 6.66927C1.1665 10.2815 5.1665 12.0026 6.49984 14.6693Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.5d823c37ddff976a2d214af35c9a39cf.svg";
export { ForwardRef as ReactComponent };